import { Box, Container, Grid, Typography } from '@mui/material';

import React from 'react';
import { Button } from '@mui/material';

import SkillBar from 'react-skillbars';

const About = () => {
  const skills = [
    {
      type: 'CSS',
      level: 85
    },
    {
      type: 'SCSS',
      level: 75
    },
    {
      type: 'Javascript',
      level: 80
    },
    {
      type: 'React',
      level: 85
    },
    {
      type: 'NextJS',
      level: 85
    },
    {
      type: 'Redux',
      level: 80
    },
    {
      type: 'Tailwind',
      level: 80
    },
    {
      type: 'Animation',
      level: 65
    }
  ];

  const colors = {
    bar: '#3498db',
    title: {
      text: '#fff',
      background: '#2980b9'
    }
  };
  return (
    <Box
      sx={{
        textAlign: 'justify',
        pt: { xs: 10, sm: 15, md: '40vh', lg: '40vh', xl: '400px' },
        pb: { xs: 10, sm: 15, md: 10, lg: 10 },
        Height: '100%',
        display: 'flex',
        alignItems: 'center',
        bgcolor: 'aliceBlue'
      }}
    >
      <Container>
        <Grid container spacing={10}>
          <Grid item xs={12} md={6}>
            <Box>
              <Typography variant="h3" sx={{ fontWeight: 'bold', mb: 2 }}>
                About Myself
              </Typography>
              <Typography>
                I am Kawsar Ahmed, a &lt;React /&gt; developer working on
                Frontend technologies at Betafore. I am passionate and dynamic,
                exploring new technologies that push me to take on further
                challenges along with my goals. I started my journey with
                Robotics development which helped me to build a strong
                foundation in Hardware programming. Later, I started learning
                Web Development from a professional course arranged by
                Programming Hero. I am progressively developing my skills,
                structuring my foundation, and building up my experiences in Web
                Technologies to stay up-to-date with professional requirements.
              </Typography>
              <a
                href="https://drive.google.com/file/d/1t3iPlERPfZmr9_V8JVGL2FIFKHnmWVhM/view?usp=sharing"
                style={{ textDecoration: 'none' }}
                target="_blank"
                rel="noreferrer"
              >
                <Button sx={{ mt: 2 }} variant="contained">
                  Download Resume
                </Button>
              </a>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box>
              <SkillBar skills={skills} colors={colors} />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default About;
